module.exports = __webpack_public_path__ + "6efa80b5bbe13d861d153c44b4092bed.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/face/makeup-sunset-s.png
// module id = 1849
// module chunks = 0